import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// MUI Components
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TablePagination, Autocomplete, TextField, Checkbox, IconButton, Box
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TableFooter from '@mui/material/TableFooter';

// MUI Icons
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

// Custom Components
import CMreadonlyrow from './StoreOffReadOnly';
import CMeditablerow from './StoreOffEditable';

// API Queries & Mutations
import { useGetAssetMastersQuery } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import {
  useGetStoreOfficesQuery,
  useAddNewStoreOfficeMutation,
  useUpdateStoreOfficeMutation,
  useDeleteStoreOfficeMutation
} from '../../../features/storeoffices/storeofficesApiSlice';
import { useGetofficesQuery } from '../../../features/offices/officesApiSlice';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';

// Utility Functions & Styles
import nameStringFn from '../../../data/nameStringFn';
import { HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import { TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import { useGetconsumcatQuery } from '../../../features/consumcat/consumcatApiSlice';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`
const ChipDiv = styled.div`
  background-color: #d4d5d6;
  display: inline-block;
  font-size: 14px;
  border-radius: 30px;
  height: 30px;
  padding: 0 4px 0 1rem;
  display: inline-flex;
  align-items: center;
  margin: 0 0.3rem 0.3rem 0;
`

const AssetCategoryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const SubmitButton = styled(CommonButton)`
  height:"40px";
  margin-top:"0px";
  margin-bottom:"0px";
`

const ComplaintCategoryWrapper =styled.div`
  display: flex;
`
const storeUserFetcher = (office, userArray) => {
  const officeUsers = userArray.filter(x => ([x.office.mainCharge].concat(x.office.additionalCharge)).includes(office));
  const assetManagerLvl1 = officeUsers.filter(x => x.roles[office].includes("assetManagerLvl1"))
  const assetManagerLvl2= officeUsers.filter(x => x.roles[office].includes("assetManagerLvl2"))
  return {"assetManagerLvl1":assetManagerLvl1,"assetManagerLvl2":assetManagerLvl2 }
}
//This is a function which returns true if
// 1. If B is an Array there should be atleast one common element between A & B.
// 2. If B is String the Array A should have one of the element as that string.

const hasCommonElement = (A, B) => {
  if (Array.isArray(B)) {
    // Check if there is at least one common element between arrays A and B
    return A.some(element => B.includes(element));
  } else if (typeof B === 'string') {
    // Check if array A contains the string B
    return A.includes(B);
  } else {
    // Handle other cases (e.g., B is neither an array nor a string)
    return false;
  }
}

const tableFontSize = 14;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const {user} = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
        user: data?.entities
    }),
  })
  const {storeoffices} = useGetStoreOfficesQuery("storeOffList", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  })
  console.log(storeoffices)
  const {offices} =  useGetofficesQuery("OffList", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })
  const {assetmaster} = useGetAssetMastersQuery('arg', {
    selectFromResult: ({ data }) => ({
        assetmaster: data?.entities
    }),
  })
  const {consumablecat} = useGetconsumcatQuery('arg', {
    selectFromResult: ({ data }) => ({
      consumablecat: data?.entities
    }),
  })
  
  
  const [addNewStoreOffice] = useAddNewStoreOfficeMutation();
  const [updateStoreOffice] = useUpdateStoreOfficeMutation();
  const [deleteStoreOffice
    , {
  isSuccess: deleteStoreOfficeisSuccess,
  isError: deleteStoreOfficeisError,
  error: deleteStoreOfficeError

  }
  ] = useDeleteStoreOfficeMutation();
  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [addNewStoreOff, setAddNewStoreOff] = useState({
    storeoffice:"",
    ApplAssetCateg:[],
    ApplConsumCateg:[],
    roleUsers: {
      assetadder: "",
      level1approver: "",
      level2approver: "",
      supportadmin: ""
    }
  })
 
  const [editFormData, setEditFormData] = useState({
    id:"",
    storeoffice:"",
    ApplAssetCateg:[],
    ApplConsumCateg:[]
  }) 

  const [searchData, setSearchData] = useState({
    storeoffice:"",
    ApplAssetCateg:[],
    level1approver:"",
    level2approver:""
  });

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    try{
      const found = Object.values(storeoffices).some(el => el.storeoffice === addNewStoreOff.storeoffice);
      const foundInExisting = Object.values(offices).some(el => el.name === addNewStoreOff.storeoffice)

    if(!addNewStoreOff?.storeoffice?.length){
      alert("Enter suitable name for store office")
      return;
    }
    if(found){
      alert(`${addNewStoreOff?.storeoffice} already exists as store office`);
      return;
    }
    if(!foundInExisting){
      alert(`${addNewStoreOff?.storeoffice} doesnot exist in the list of available offices`);
      return;
    }
    if(!addNewStoreOff?.ApplAssetCateg?.length){
      alert("Select atleast one applicable asset category.")
      return;
    }
    const res = await addNewStoreOffice(addNewStoreOff) ;
    console.log(res)
    setAddNewStoreOff({
      storeoffice:"",
      ApplAssetCateg:[],
      roleUsers:{
        level1approver:"",
        level2approver:"",
        assetadder:"",
        supportadmin:""
      }
    })
    } catch(err){console.log(err)}
  }


  const onClickEdit = (e, k, row) => {
    setEditFormData(prev => ({
      ...prev,
      id: row.id,
      storeoffice: row.storeoffice,
      ApplAssetCateg: row.ApplAssetCateg,
      ApplConsumCateg: row.ApplConsumCateg
    }));
    setEditCategory(k + 1);
  };

  const onChangeAddStoreOff = (event, newValue, name) => {
    setAddNewStoreOff(prev => ({
        ...prev,
        [name]: newValue || "", // Update top-level fields safely
    }));
  };

  const onChangeEditCateg = (event, newValue, name) => {
    setEditFormData(prev => ({
      ...prev,
      ...(event.target?.name ? { [event.target.name]: event.target.value } : {}),
      ...(name ? { [name]: newValue } : {})
    }));
  }; 

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    if (!editFormData?.ApplAssetCateg?.length || !editFormData?.ApplConsumCateg?.length){
      alert("Please select all values before submitting");
      return;
    }
    try{
    setEditCategory(null);
    const response = await updateStoreOffice(editFormData)
    alert(`Store Office"${editFormData?.storeoffice}" updated successfully`);

    }catch(err){
      console.error("Error updating designation:", err);
      alert("An error occurred while updating the store office");
    }
  }
  

  const handleCancelClick = (e,k) => {    
    setEditCategory(null);
  };

  const handleDeleteClick = async (e,k,row) => {
    e.preventDefault();
    let body = {"id":row.id}
    const response = window.confirm(`Do you want to store office "${row.storeoffice}"` )
    if(!response) return;
    const result = await deleteStoreOffice(body);
    if(result) alert(`Store Office "${row.storeoffice}" deleted successfully`);
  };

  const handleSearchChange = (event, newValue, name) =>{
    let tempData = structuredClone(Object.values(storeoffices));
    let tempSearchData = structuredClone(searchData);
    console.log(event?.target?.name)
    console.log(event?.target?.value)

    if(event?.target?.name){
      tempSearchData[event.target.name] = event.target.value;
      setSearchData(tempSearchData);
     }else{
      tempSearchData[name] = newValue
      setSearchData(tempSearchData);
     }
     for(let key in tempSearchData){
      console.log(tempSearchData[key])
      if(key === "storeoffice" && tempSearchData[key].length){  
        console.log("Entered")      
          tempData = tempData.filter(x=> x[key].toLowerCase().includes(tempSearchData[key].toLowerCase()))
          console.log(tempData)}
      if (key === "ApplAssetCateg" && tempSearchData[key].length ){
        tempData = tempData.filter(x=> hasCommonElement(tempSearchData[key], x[key]))
      }
      if (["level1approver", "level2approver","assetadder"].includes(key) && tempSearchData[key].length ){
        tempData = tempData.filter(x=> nameStringFn(user[x.roleUsers[key]]).toLowerCase().includes(tempSearchData[key].toLowerCase()))
      }
    }
    setTabledata(tempData.sort((a,b) => b.level - a.level));
  }


  useEffect(()=>{
    if(storeoffices){
      const storeofficesArray = Object.values(storeoffices);
      setTabledata(storeofficesArray);     
    }
  },[storeoffices])

  console.log(addNewStoreOff)
   
  return (
    <>
    <Displaydiv1>
      <HeadingWrap>
        <Span>Add New Store Office</Span>
      </HeadingWrap>
    <ComplaintCategoryWrapper>
    <Addcategform onSubmit={onSubmit}>
    <AssetCategoryWrapper>
      <Autocomplete
        disablePortal
        size="small"
        id="combo-box-demo"
        value={addNewStoreOff.storeoffice || ""} // Ensure value is never undefined
        options={offices ? Object.values(offices).map(x => x?.name) : []} // Provide an empty array as fallback
        onChange={(event, newValue) => onChangeAddStoreOff(event, newValue, "storeoffice")}
        sx={{ width: 250, marginRight: "20px" }}
        renderInput={(params) => (
            <TextField
                {...params}
                label="Select Office For Store"
                sx={{ background: "white" }}
            />
        )}
      />
      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        size="small"
        value={addNewStoreOff?.ApplAssetCateg ?? []} // Use nullish coalescing for safety
        onChange={(event, newValue) => onChangeAddStoreOff(event, newValue, "ApplAssetCateg")}
        options={assetmaster ? Object.values(assetmaster).map(x => x?.Category).sort() : []}
        disableCloseOnSelect
        getOptionLabel={(option) => option || ""} // Fallback to an empty string
        renderOption={(props, option, { selected }) => (
          <li {...props} style={{ fontSize: '1rem' }}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 0, marginLeft: -8 }}
              checked={selected}
            />
            {option}
          </li>
        )}
        sx={{ width: 250, marginRight: "20px", }}
        renderInput={(params) => (
          <TextField 
            {...params} 
            label="Select Asset Category" 
            sx={{ background: "white",  width: "100%" }} 
          />
        )}
      />
      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        size="small"
        value={addNewStoreOff?.ApplConsumCateg ?? []} // Use nullish coalescing for safety
        onChange={(event, newValue) => onChangeAddStoreOff(event, newValue, "ApplConsumCateg")}
        options={
          consumablecat
            ? [...new Set(Object.values(consumablecat).map(x => x?.name))].sort()
            : []
        }        
        disableCloseOnSelect
        getOptionLabel={(option) => option || ""} // Fallback to an empty string
        renderOption={(props, option, { selected }) => (
          <li {...props} style={{ fontSize: '1rem' }}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 0, marginLeft: -8 }}
              checked={selected}
            />
            {option}
          </li>
        )}
        sx={{ width: 250 }}
        renderInput={(params) => (
          <TextField 
            {...params} 
            label="Select Consum Category" 
            sx={{ background: "white", width: "100%" }} 
          />
        )}
      />
    <SubmitButton type='submit'>Submit</SubmitButton>


    </AssetCategoryWrapper>
        {/* <button type='submit'>Submit</button> */}
    </Addcategform>
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer 
      component={Paper} 
      sx={{ 
        backgroundColor: TableContStyle.backgroundColor,
        width: '100%',
        overflowX: 'auto',
        '& .MuiTable-root': {
          minWidth: '1400px'
        }
      }}  
    >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"3%", sm:"4%", md:"5%"}}}align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"12%", sm:"15%", md:"18%"}}}align="left">Store Office</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"15%", sm:"18%", md:"20%"}}}align="left">Applicable Asset Categories</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"15%", sm:"18%", md:"20%"}}}align="left">Applicable Consum Categories</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">Item Adder (A)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L1Approver (A)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L2Approver (A)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L1ReqApprover (A)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L2ReqApprover (A)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">Item Adder (C)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L1Approver (C)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L2Approver (C)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L1ReqApprover (C)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L2ReqApprover (C)</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L1Support</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"8%", sm:"10%", md:"15%"}}}align="left">L2Support</TableCell>
          <TableCell style={{ fontSize: 14, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{xs:"6%", sm:"8%", md:"10%"}}}align="left">Edit</TableCell>
        </TableRow>

        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell >
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='storeoffice' onChange={handleSearchChange} label="Search Store Office" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "ApplAssetCateg")}
              size="small"
              value={searchData.level}
              options={storeoffices? [...new Set(Object.values(storeoffices).flatMap(x=>x.ApplAssetCateg))].sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => String(option)}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '12px' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Categories"  sx={{background:"white", width:"90%", fontSize: "12px"}} />
              )}
              />           
          </TableCell>

          <TableCell >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "ApplConsumCateg")}
              size="small"
              value={searchData.level}
              options={storeoffices? [...new Set(Object.values(storeoffices).flatMap(x=>x.ApplAssetCateg))].sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => String(option)}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '12px' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Consum Categories"  sx={{background:"white", width:"90%", fontSize: "12px"}} />
              )}
              />           
          </TableCell>

          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='assetadder' onChange={handleSearchChange} label="Search Asset Adder" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='level1approver' onChange={handleSearchChange} label="Search L1Approver" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='level2approver' onChange={handleSearchChange} label="Search L2Approver" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='l1reqapprover' onChange={handleSearchChange} label="Search L1ReqApprover" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='l2reqapprover' onChange={handleSearchChange} label="Search L2ReqApprover" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='citemadder' onChange={handleSearchChange} label="Search CItem Adder" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='cl1approver' onChange={handleSearchChange} label="Search CL1Approver" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='cl2approver' onChange={handleSearchChange} label="Search CL2Approver" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='cl1reqapprover' onChange={handleSearchChange} label="Search CL1ReqApprover" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='cl2reqapprover' onChange={handleSearchChange} label="Search CL2ReqApprover" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='l1support' onChange={handleSearchChange} label="Search L1Support" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
            <TextField sx={{background:"white", fontSize: "12px"}}  name='l2support' onChange={handleSearchChange} label="Search L2Support" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <CMeditablerow row={row} k={key} editFormData={editFormData}
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage}
                editCategory={editCategory} onChangeEditCateg={onChangeEditCateg}
                assetmaster={assetmaster} nameStringFn={nameStringFn} consumablecat={consumablecat}
                tableFontSize ={tableFontSize} SubmitButton={SubmitButton} user={user} icon={icon}
                checkedIcon={checkedIcon} 
               />

                :<CMreadonlyrow row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit} 
                handleDeleteClick= {handleDeleteClick} page={page}rowsPerPage={rowsPerPage} ChipDiv={ChipDiv}
                storeUserFetcher={storeUserFetcher} user={user} nameStringFn = {nameStringFn}
                tableFontSize ={tableFontSize} SubmitButton={SubmitButton}          
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>
    </Displaydiv1>
    </>
  );
}